import { render, staticRenderFns } from "./FloatLabel.vue?vue&type=template&id=56fa8d1e&"
import script from "./FloatLabel.vue?vue&type=script&lang=js&"
export * from "./FloatLabel.vue?vue&type=script&lang=js&"
import style0 from "./FloatLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports